import { createNavigationView } from './index'
import { VIEW_EMPLOYER } from '../constants'

const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')
const BidCards = () => import('../components/BidCards/BidCards.vue')
const EditBidCard = () => import('../components/BidCards/EditBidCard.vue')
const EditBidCardModal = () => import('../components/BidCards/EditBidCardModal.vue')
const ResetBidCardModal = () => import('../components/BidCards/ResetBidCardModal.vue')
const BidCardDetailsModal = () => import('../components/BidCards/BidCardDetailsModal.vue')

export const routes = () => [
  {
    path: '/ajanlati-kartyaim',
    components: {
      default: BidCards,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: ':id/torles',
        component: ResetBidCardModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Bid Cards - Delete',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_EMPLOYER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id',
        component: BidCardDetailsModal,
        props: route => ({ id: route.params.id, size: 'large' }),
        meta: {
          isModal: true,
          pageTitle: 'Bid Cards - Details',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_EMPLOYER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/modositas-megerositese',
        component: EditBidCardModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Bid Cards - Confirm Edit',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_EMPLOYER,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Bid Cards',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_EMPLOYER,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/ajanlati-kartyaim/:id/modositas',
    components: {
      default: EditBidCard,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Bid Cards - Edit',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_EMPLOYER,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/bid-cards.js